import { BlockWrapper, defineBlock, smartProps, useEditor } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import Burger from './burger/index.js';
import { useState } from 'react';
import Logo from './Logo/index';
import Top from './Top/index';
import CategoryList from './CategoryList/index';
import Socials from './Socials/index';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';

function Header({ categoryList, socials, languages, categoriesAlias }) {
    let breakpointValue = parseInt(style.tabletBreakpoint) + 1;
    const isDesktop = useMediaQuery({
        query: '(min-width: ' + breakpointValue + 'px)',
    });

    const { isEditing } = useEditor();

    const [showMenu, setShowMenu] = useState(false);

    return (
        <BlockWrapper.Div className={clsx(style.block, isEditing && style.admin)}>
            {isDesktop ? (
                <div className={clsx(style.desktop, isEditing && style.admin)}>
                    <Top languages={languages} />
                    <Logo />
                    <CategoryList categoryList={categoryList} categoriesAlias={categoriesAlias} />
                </div>
            ) : (
                <div className={style.bar}>
                    <div onClick={() => setShowMenu(!showMenu)}>
                        <Burger open={showMenu} />
                    </div>
                    <Logo />
                    <div className={clsx(style.menuBurger, showMenu && style.active)}>
                        <CategoryList categoryList={categoryList} categoriesAlias={categoriesAlias} />
                        <Top languages={languages} setShowMenu={setShowMenu} />
                        <Socials socials={socials} />
                    </div>
                </div>
            )}
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Header,
    smartProps: {
        simple_logo: smartProps.image,
        big_logo: smartProps.image,
        simple_logo_white: smartProps.image,
    },
    setup: {
        title: 'Header',
        icon: 'table-row-before',
    },
});
